export default __webpack_public_path__ + "media/images/dog-cta-6c4d04ef813e36fc74e41cd14e69ae83.svg";